var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetmap = function SvgAssetmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5A623",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "m6.128 4.895-1.433.831c-1.153.669-1.73 1.003-2.046 1.56-.317.556-.317 1.233-.317 2.588V19.4c0 1.78 0 2.67.4 3.165.265.33.637.552 1.049.625.619.11 1.376-.329 2.89-1.207 1.03-.597 2.02-1.217 3.25-1.049.56.076 1.094.342 2.162.873l4.45 2.212c.961.479.97.481 2.04.481H21c2.2 0 3.3 0 3.983-.698.683-.699.683-1.823.683-4.072v-7.863c0-2.249 0-3.373-.683-4.071-.683-.699-1.783-.699-3.983-.699h-2.425c-1.07 0-1.08-.002-2.042-.48l-3.887-1.933c-1.623-.807-2.434-1.21-3.299-1.183-.864.028-1.649.484-3.218 1.394M9.332 3.5v16.917M17.5 7.584v16.333"
  })));
};
export default SvgAssetmap;